import type { Site } from '~/interfaces/site';
import type { Subscription } from '~/interfaces/subscriptions';

export const useResetPassword = (site: Site, subscription: Subscription, isSubscriptionInvalid: boolean) => {
  return {
    canResetPassword: !!site?.viewable_site_version?.settings?.subscriber_password_enabled && !isSubscriptionInvalid,
    hasSetPassword: !!subscription?.password_exists,
  };
};
